/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const skillSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  critical: z.boolean(),
  id: z.int(),
  instanceId: z.string().nullish(),
  lastSyncedAt: z.iso.datetime().nullish(),
  name: z.string(),
  organizationId: z.string(),
  resourceCount: z.int().nullish(),
  sourceId: z.string().nullish(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
